'use client'

import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export const SandboxFeaturesCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('supportedOperations')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <h4 className="mb-2 text-sm font-medium text-gray-700">
                            {t('transactionTypes')}
                        </h4>
                        <ul className="list-disc space-y-1 pl-4 text-sm text-gray-600">
                            <li>{t('sandboxOperation1')}</li>
                            <li>{t('sandboxOperation2')}</li>
                            <li>{t('sandboxOperation3')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-2 text-sm font-medium text-gray-700">
                            {t('postTransactionOperations')}
                        </h4>
                        <ul className="list-disc space-y-1 pl-4 text-sm text-gray-600">
                            <li>{t('sandboxOperation4')}</li>
                            <li>{t('sandboxOperation5')}</li>
                            <li>{t('sandboxOperation6')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-2 text-sm font-medium text-gray-700">
                            {t('paymentMethods')}
                        </h4>
                        <ul className="list-disc space-y-1 pl-4 text-sm text-gray-600">
                            <li>{t('sandboxOperation7')}</li>
                            <li>{t('sandboxOperation8')}</li>
                            <li>{t('sandboxOperation9')}</li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-2 text-sm font-medium text-gray-700">
                            {t('integrationFeatures')}
                        </h4>
                        <ul className="list-disc space-y-1 pl-4 text-sm text-gray-600">
                            <li>{t('sandboxOperation10')}</li>
                            <li>{t('sandboxOperation11')}</li>
                            <li>{t('sandboxOperation12')}</li>
                            <li>{t('sandboxOperation13')}</li>
                            <li>{t('sandboxOperation14')}</li>
                        </ul>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

